// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__EuZp5","top":"styles_top__1MuMX"};